import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Upload avatar
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestUploadOrganizationAvatar = packet => {
  return {
    type: 'REQUEST_UPLOAD_ORGANIZATION_AVATAR',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUploadOrganizationAvatarSuccess = data => ({
  type: 'RECEIVE_UPLOAD_ORGANIZATION_AVATAR_SUCCESS',
  data
})

export const receiveUploadOrganizationAvatarFail = data => ({
  type: 'RECEIVE_UPLOAD_ORGANIZATION_AVATAR_FAIL',
  data
})

export const tryToUploadOrganizationAvatar = packet => (dispatch, getState) => {

  dispatch(requestUploadOrganizationAvatar(packet));

  let headers = {
    // "Content-Type": "application/json",
    "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH),
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  var data = new FormData()
  data.append('file', packet.file)

  return fetch('/api/organizations/avatar/' + packet.id, {
      method: 'post',
      body: data,
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUploadOrganizationAvatarSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUploadOrganizationAvatarFail({errors:e, lastSubmit: packet}));
    })
}
